import React from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { updateAutomationErrors, updateAutomationDraft } from '../../../state/automationsSlice';
import { AutomationsFieldLabel } from '../../Layout';
import { useGetFieldErrorText } from 'pages/Automations/hooks/useGetFieldErrorText';

export const AutomationName = (): JSX.Element => {
  const automationName = useAppSelector((state) => state.automations.automationDraft.automationName);
  const fieldErrors = useAppSelector((state) => state.automations.errors.automationName);
  const errorText = useGetFieldErrorText(fieldErrors);
  const dispatch = useAppDispatch();

  const handleAutomationNameChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    dispatch(updateAutomationDraft({ automationName: event.target.value }));

    if (Boolean(fieldErrors.length)) {
      dispatch(updateAutomationErrors({ automationName: [] }));
    }
  };

  return (
    <Box mb={10}>
      <AutomationsFieldLabel>Automation Name</AutomationsFieldLabel>
      {/* TODO: Add auto focus to this field when creating a new automation */}
      <TextInput
        value={automationName || ''}
        placeholder="New Automation"
        errorText={errorText}
        mt={2}
        isInvalid={Boolean(fieldErrors.length)}
        className="Automations__TextInput"
        onChange={handleAutomationNameChange}
      />
    </Box>
  );
};
